import { createSlice } from '@reduxjs/toolkit';

import axios from '../../utils/axios';
import utils from '../../utils/utils';
import { dispatch } from '../index';

const PATH = 'exercise-tags';
const navigateTo = '/exercise-tags';

const initialState = {
    exerciseTags: [],
    exerciseTagsObject: [],
    error: null,
    totalPages: 1,
    loading: false,
    limit: 10,
    currentPage: 1
};

// Reducer
const slice = createSlice({
    name: 'exerciseTags',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
            state.loading = false;
        },

        startLoading(state, action) {
            state.loading = true;
        },
        stopLoading(state, action) {
            state.loading = false;
        },

        // GET USERS STYLE 1
        getSuccess(state, action) {
            const data = action.payload.data;
            state.exerciseTags = utils.sortAlphatically(data, 'name');
            state.exerciseTagsObject = utils.getUniqueObject(data, 'id');
            const total = action.payload.totalItems;
            let pages = Math.floor(total / state.limit);
            const remainder = total % state.limit;
            if (remainder !== 0) {
                pages += 1;
            }
            state.totalPages = pages;
            state.loading = false;
        },
        addSuccess(state, action) {
            state.loading = false;
        },
        editSuccess(state, action) {
            state.loading = false;
        },
        deleteSuccess(state, action) {
            state.loading = false;
            state.locations = state.exerciseTags.filter((item) => item.id !== action.payload.id);
        },
        setCurrentPage(state, action) {
            console.log(action.payload);
            state.currentPage = action.payload;
        }
    }
});

export default slice.reducer;

// Actions

export function startLoading() {
    return async () => {
        dispatch(slice.actions.startLoading());
    };
}

export function stopLoading() {
    return async () => {
        dispatch(slice.actions.stopLoading());
    };
}

export function getExerciseTags() {
    return async () => {
        try {
            const result = await axios.get(`/${PATH}?size=1000`);
            console.log('RES [getExerciseTags]:', result.data);
            dispatch(slice.actions.getSuccess(result.data));
        } catch (error) {
            console.log('ERR [getExerciseTags]:', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function addExerciseTag(data, navigate) {
    return async () => {
        try {
            const result = await axios.post(`/${PATH}`, data);
            console.log('RES [addExerciseTag] ======> ', result.data.data);
            dispatch(slice.actions.addSuccess(result.data.data));
            navigate(navigateTo);
        } catch (error) {
            console.log('ERR [addExerciseTag] =======> ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function editExerciseTag(id, data, navigate) {
    return async () => {
        try {
            const result = await axios.put(`/${PATH}/${id}`, data);
            console.log('RES [editExerciseTag] =======> ', result?.data?.data);
            dispatch(slice.actions.editSuccess(result?.data?.data));
            navigate(navigateTo);
        } catch (error) {
            console.log('ERR [editExerciseTag] ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function deleteExerciseTag(id = '') {
    return async () => {
        try {
            const result = await axios.delete(`/${PATH}/${id}`);
            console.log('RES [deleteExerciseTag] =======> ', result);
            dispatch(slice.actions.deleteSuccess(result.data.data));
            dispatch(getExerciseTags())
        } catch (error) {
            dispatch(getExerciseTags())
            console.log('ERR [deleteExerciseTag] =========> ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function setCurrentPage(page) {
    return async () => {
        dispatch(slice.actions.setCurrentPage(page));
    };
}
